export default "__VITE_ASSET__usiQKNez__"